import { render, staticRenderFns } from "./WeCom-Message.vue?vue&type=template&id=4c126a74"
import script from "./WeCom-Message.vue?vue&type=script&lang=js"
export * from "./WeCom-Message.vue?vue&type=script&lang=js"
import style0 from "./WeCom-Message.vue?vue&type=style&index=0&id=4c126a74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports